import { createApi } from "./client";
import type { DiscountCodePreview } from "../types/models";

/** Preview van een kortingscode vóór het boeken — verbruikt de code nog niet. Gooit bij een
 * ongeldige/verlopen/verkeerd-gescoopte code (aanroeper vangt dit stil af, zie BookFlow). */
export function previewDiscountCode(
    apiBase: string,
    companySlug: string,
    code: string,
    serviceId: number,
    staffId: number
): Promise<DiscountCodePreview> {
    const api = createApi(apiBase);
    return api<DiscountCodePreview>(
        `/api/companies/${companySlug}/discount-codes/${encodeURIComponent(code)}?serviceId=${serviceId}&staffId=${staffId}`
    );
}
